/* Short Listicle — lightweight tracking: CTA clicks, scroll depth,
   per-reason visibility. No UI behaviour — the page is static. */
(function () {
  'use strict';

  function track(event, detail) {
    document.dispatchEvent(new CustomEvent(event, { detail: detail }));
    if (window.dataLayer) {
      window.dataLayer.push(Object.assign({ event: event }, detail));
    }
  }

  var ctaBound = false;
  function initCtaTracking() {
    if (ctaBound) return;
    ctaBound = true;
    document.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-sl-cta]');
      if (cta) {
        track('sl:cta_click', { placement: cta.dataset.slCta });
      }
    });
  }

  var depthsFired = {};
  function initScrollDepth() {
    var thresholds = [25, 50, 75, 100];
    function onScroll() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var pct = Math.round(((window.scrollY || doc.scrollTop) / scrollable) * 100);
      thresholds.forEach(function (t) {
        if (pct >= t && !depthsFired[t]) {
          depthsFired[t] = true;
          track('sl:scroll_depth', { depth: t });
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initReasonViews(scope) {
    if (!('IntersectionObserver' in window)) return;
    var reasons = (scope || document).querySelectorAll('.sl-reason:not([data-sl-seen-bound])');
    if (!reasons.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            track('sl:reason_view', { index: entry.target.dataset.slReasonIndex });
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    reasons.forEach(function (el) {
      el.setAttribute('data-sl-seen-bound', '');
      io.observe(el);
    });
  }

  function initAll(scope) {
    initCtaTracking();
    initScrollDepth();
    initReasonViews(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReasonViews(event.target);
  });
})();
